import { gsap } from 'gsap';
import '../util/easings';
import { mq } from '../util/matchMedia';

export const animateIn = (() => {
  const tl = gsap.timeline({ paused: true });
  let logo, text, nav, navLogo;

  const init = () => {
    getReferenceElements();
    setUpTimeline();
    play();
  }

  const play = () => tl.play(0);

  const getReferenceElements = () => {
    logo = document.querySelector('.js-contact-logo');
    text = document.querySelector('.js-contact-text');
    nav = document.querySelector('.js-navigation');
    navLogo = document.querySelector('.js-navigation-logo');
  }

  const setUpTimeline = () => {
    tl
      .fromTo(logo,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.583,
          ease: 'kota.easeIn.1',
        }, 0)
      .fromTo(logo,
        { y: 20 },
        {
          y: 0,
          duration: 0.583,
          ease: 'kota.easeInOut.6',
        }, 0)
      .fromTo(text,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.583,
          ease: 'kota.easeIn.1',
        }, 0.2)
      .fromTo(text,
        { y: 20 },
        {
          y: 0,
          duration: 0.583,
          ease: 'kota.easeInOut.6',
        }, 0.2)
      .set(nav, {
        autoAlpha: 1,
      }, 0)

    if (mq.isDesktop) {
      tl.set(navLogo, {
        autoAlpha: 1,
      }, 0);
    }
  }

  return { init, play };
})();
